export const dataModel = {
  url: "/api/dynamiceventslisting",
  loadMore: true,
  initialResults: 15,
  perPage: 10,
  loadMoreText: "More Events",
  showFacetsLabel: "Filters",
  clearAllLabel: "Reset",
  facetKeys: [
    "academicDepartments",
    "eventTypes",
    "eventDateRange"
  ],
  includeSearchBar: true,
  searchPlaceholder: "Search Events",
  noPastEventsText: "<p>No past events found.</p>",
  noUpcomingEventsText: "<p>No upcoming events found.</p>",
  eventTypeFilterMessage:"<p>Please select a department to filter by event type.</p>"
};

export const dataQuery = {
  pageId: "a99f62d0-8603-4122-a711-528a1e77c3c3",
  listingId: "7c2b1ff2-923f-42c1-ae44-59a48b6b73aa"
};

export const mockApiResponse = {
  request: {
    pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
    page: 1,
    perPage: 5,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {},
  },
  totalResults: 3,
  results: [
    {
      key: "{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC}",
      linkUrl: "/velir-test/event-page-1.aspx",
      type: "Research Seminar",
      department: "Accounting Information & Management",
      title: "Ken Wilbur",
      description: "Forthcoming<br>Possibly Multi Line",
      date: "March 6, 2024",
      time: "6:00 p.m.",
      timezone: "CT",
      facultyLocation: "University of California, San Diego",
      locationOne: "Global Hub<br>L120",
      mobileLocationOne: "Global Hub, L120",
      registrationLinkLabel: "Add To Calendar",
      registrationLinkUrl: "/api/calendar/{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC}"
    },
    {
      key: "{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC0}",
      linkUrl: "/velir-test/event-page-1.aspx",
      type: "Political Economy Seminar",
      department: "Finance",
      title: "Operations Seminar — Alexandre Belloni",
      description: "Neighborhood adaptive estimates for casual inference under network interference",
      date: "March 15, 2024",
      time: "12:00 p.m.",
      timezone: "CT",
      facultyLocation: "University of California, San Diego",
      locationOne: "Global Hub<br>4101<br>Virtual option",
      mobileLocationOne: "Global Hub, 4101, Virtual option",
      registrationLinkLabel: "Add To Calendar",
      registrationLinkUrl: "/api/calendar/{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC}"
    },
    {
      key: "{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC1}",
      linkUrl: "/velir-test/event-page-1.aspx",
      type: "Brown Bag Seminar",
      department: "Management & Organizations",
      title: "Nicola Bianchi",
      description: "One cohort at a time: A new perspective on the declining gender pay gap",
      date: "April 28, 2024",
      time: "12:05 p.m.",
      timezone: "CT",
      facultyLocation: "Kellogg School of Management",
      locationOne: "Global Hub<br>4302<br>Virtual option",
      mobileLocationOne: "Global Hub, 4302, Virtual option",
      registrationLinkLabel: "Add To Calendar",
      registrationLinkUrl: "/api/calendar/{EE08E2ED-CCA1-4CCB-8BC1-32FB57D616DC}"
    },
  ],
  facets: [
    {
      id: "academicDepartments",
      label: "Academic Departments",
      values: [
        {
          id: "Operations",
          name: "Operations",
          count: 1,
          selected: false,
          childValues: []
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 1,
          selected: false,
          childValues: []
        }
      ],
      childGroups: []
    },
    {
      id: "eventTypes",
      label: "Event Types",
      values: [
        {
          id: "Political Economy Seminar",
          name: "Political Economy Seminar",
          count: 1,
          selected: false,
          childValues: []
        }
      ],
      childGroups: []
    },
    {
      id: "eventDateRange",
      label: "Date Range",
      values: [
        {
          id: "Upcoming events",
          name: "Upcoming events",
          count: 1,
          selected: true,
          childValues: []
        },
        {
          id: "Past events",
          name: "Past events",
          count: 1,
          selected: false,
          childValues: []
        }
      ],
      childGroups: []
    }
  ]
};
